import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import { getCurrencySymbol } from '@spa/shared/utils/money';
import { Container, Label, Value } from './styles';

const BudgetInput = ({
  name,
  label,
  onChange,
  value = '',
  currencyCode = 'EUR',
  onFocus = () => {},
  onBlur = () => {}
}) => {
  const inputRef = useRef(null);
  const currencySymbol = useMemo(() => getCurrencySymbol(currencyCode), [currencyCode]);

  return (
    <Container onClick={() => inputRef.current.focus()}>
      <Label htmlFor={name}>
        {label}
        <Value>
          <span>{currencySymbol}</span>
          <input name={name} ref={inputRef} onChange={onChange} onBlur={onBlur} onFocus={onFocus} value={value} />
        </Value>
      </Label>
    </Container>
  );
};

BudgetInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currencyCode: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired
};

export { BudgetInput };
